export default "__VITE_ASSET__0k0JMxb0__"